export default __webpack_public_path__ + "static/tutorials-intro-c0e42c79a1fc2671a736f341bc28d808.png";